(ns ductile.ui.elog.interface
  (:require [applied-science.js-interop :as j]
            [clojure.string :as str]
            [ductile.time.format :as time-format]
            [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.forms :as forms.ui]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.util :as util]
            [inside-out.forms :as forms]
            [inside-out.reagent :refer [with-form]]
            [kitchen-async.promise :as p]
            [nextjournal.clerk.render :as clerk.render]
            [nextjournal.log :as log]
            [reagent.core :as r]))

(defn submitted-services-list [{:keys [submitted-services]}]
  [:div.p-6
   [:div.border-t.bg-gray-50.px-5.py-2.rounded-t.border-x
    [:h2.text-lg.m-0.font-bold (tr "Submitted services")]]
   [:div.rounded.bg-white
    [:div.overflow-hidden.rounded-sm.border
     [:table.min-w-full.divide-y.divide-slate-200.md:table.overflow-x-auto
      [:thead.bg-slate-50
       [:tr.p-3
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/4"} (tr "VIN")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/4"} (tr "Service")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/4"} (tr "Job-ID")]
        [:th.text-right.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/4"} (tr "Submitted")]]]
      (into [:tbody]
            (mapv (fn [{:keys [file-exchange/file] :as s}]
                    [:tr
                     [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/4"} (:elog/vin s)]
                     [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/4"} (:elog/service-code s)]
                     [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/4"} (:ductile/id file)]
                     [:td.px-5.text-right.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/4"}
                      (when (:file-exchange/submitted-at file)
                        (time-format/->str (:file-exchange/submitted-at file)))]])
                  submitted-services))]]]])

(defn staged-services-list [{:keys [staged-services notice]}]
  [:div.p-6
   [:div.border-t.bg-gray-50.px-5.py-2.rounded-t.border-x.flex.items-center.justify-between
    [:h2.text-lg.m-0.font-bold (tr "Staged services")]
    [:form.ml-2
     {:on-submit #(do (.preventDefault %)
                      (let [input-el (js/document.getElementById "file-upload")
                            file (first (.. input-el -files))
                            extension (last (str/split (.-value input-el) #"\."))
                            reader (js/FileReader.)]
                        (j/assoc! reader
                                  :onloadend
                                  (fn [_]
                                    (p/let [result (http/$lambda 'ductile.elog.interface/handle-upload
                                                                 {:compound-name (util/current-compound-name)
                                                                  :extension extension
                                                                  :file (.-result reader)})]
                                      (when (:error-message result)
                                        (reset! notice result)))
                                    (j/assoc! input-el :value "")))
                        (when file
                          (.readAsDataURL reader file))))}
     [ui/input {:type "file" :id "file-upload" :class "mr-2" :size 3}]
     [ui/button {:type :submit
                 :size 3} (tr "Import from CSV/Excel")]]]
   [:div.rounded.bg-white
    [:div.overflow-hidden.border
     [:table.min-w-full.divide-y.divide-slate-200.md:table.overflow-x-auto
      [:thead.bg-slate-50
       [:tr.hover:bg-gray-100.text-gray-500
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/5"} (tr "VIN")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Service")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Fuel type")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Fuel quantity")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Battery status")]
        [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Battery charge (%)")]
        [:th.text-right.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Actions")]]]
      (if (seq staged-services)
        (into [:tbody]
              (mapv (fn [{:elog/keys [service-code battery-charge battery-status fuel-type fuel-quantity] :as s}]
                      [:tr
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/5"} (:elog/vin s)]
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"} service-code]
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"} fuel-type]
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"} fuel-quantity]
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"} battery-status]
                       [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"} battery-charge]
                       [:td.px-5.text-right.py-2.whitespace-nowrap.text-xs
                        [:a.inline-flex.justify-center.text-xs.font-bold.text-red-400.hover:text-red-700.whitespace-no-wrap
                         {:on-click #(p/let [result (http/$lambda 'ductile.elog.interface/handle-remove-service-completion
                                                                  {:ductile/id (:ductile/id s)})]
                                       (when-let [error-message (:error-message result)]
                                         (reset! notice {:type :error :message error-message})))}
                         (tr "Remove")]]])
                    staged-services))
        [:tbody
         [:tr [:td.min-w-full.p-5.text-center.font-bold.text-gray-500.text-sm {:col-span "7"}
               [:span (tr "You have currently no staged services. Import them via a CSV file, or add them manually in the table below.")]]]])]]
    [:div.text-center.border-b.rounded-b-sm.border-l.border-r
     [ui/button {:variant :primary
                 :size 3
                 :class "m-3"
                 :disabled (empty? staged-services)
                 :on-click (fn [_e]
                             (p/let [result (http/$lambda 'ductile.elog.interface/handle-submit-completion
                                                          {:service-ids (mapv :ductile/id staged-services)})]
                               (when-let [error-message (:error-message result)]
                                 (reset! notice {:type :error :message error-message}))))}
      (tr "Submit")]]]])

(defn complete-service-form [{:keys [notice]}]
  (with-form [!form {:list/changes (?changes :many {:elog/vin ?vin
                                                    :elog/service-code ?service-code
                                                    :elog/fuel-quantity ?liters
                                                    :elog/fuel-type ?fuel-type
                                                    :elog/battery-charge ?battery-charge
                                                    :elog/battery-status ?battery-status})}]
    [:div.p-6
     [:div.border-t.bg-gray-50.px-5.py-2.rounded-t.border-x.flex.items-center.justify-between
      [:h2.text-lg.m-0.font-bold (tr "Services to complete")]
      [ui/button
       {:size 3
        :on-click #(do (.preventDefault %)
                       (forms/add-many! ?changes {'?vin ""
                                                  '?service-code ""
                                                  '?liters ""
                                                  '?fuel-type ""
                                                  '?battery-charge ""
                                                  '?battery-status ""}))}
       [ui/icon :plus]
       [:span.ml-1 (tr "Add service")]]]
     [:div.rounded.bg-white
      [:div.overflow-visible.rounded-t-sm.border
       [:table.min-w-full.divide-y.divide-gray-200.bg-white
        [:thead.bg-slate-50
         [:tr.hover:bg-gray-100.text-gray-500
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/5"} (tr "VIN")]
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Service")]
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/6"} (tr "Fuel type")]
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Fuel quantity")]
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Battery status")]
          [:th.text-left.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-r.border-gray-200.whitespace-nowrap {:class "w-1/12"} (tr "Battery charge (%)")]
          [:th.text-right.px-5.py-2.text-xs.font-medium.uppercase.tracking-wide.border-gray-200 {:class "w-1/12"} (tr "Actions")]]]
        (if (seq @?changes)
          (into [:tbody.bg-white.divide-y.divide-gray-200.text-xs]
                (mapv (fn [?change]
                        (let [{:syms [?vin ?liters ?fuel-type ?battery-charge ?battery-status ?service-code]} ?change]
                          [:tr.hover:bg-gray-50.cursor-pointer
                           [:td.text-left.pl-5.py-2.whitespace-nowrap.border-r {:class "w-1/5"}
                            [:div.flex.flex-col
                             [:span.font-bold.text-gray-500.text-xs.tracking-wide.px-2
                              [forms.ui/input-text ?vin {:class "w-full"}]]]]
                           [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/6"}
                            [forms.ui/input-text ?service-code {:class "w-full"}]]
                           [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"}
                            [forms.ui/combo-box ?fuel-type {:class "w-full" :options [{:key "diesel" :value "D" :label (tr "Diesel")}
                                                                                      {:key "benzin" :value "B" :label (tr "Benzine")}]}]]
                           [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"}
                            [forms.ui/input-text ?liters {:class "w-full" :type "number" :min 0 :step ".01"}]]
                           [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"}
                            [forms.ui/combo-box ?battery-status {:class "w-full" :options [{:key "ok" :value "V" :label (tr "OK")}
                                                                                           {:key "not-ok" :value "M" :label (tr "Faulty")}]}]]
                           [:td.px-5.text-left.py-2.whitespace-nowrap.text-xs.border-r {:class "w-1/12"}
                            [forms.ui/input-text ?battery-charge {:class "w-full" :type "number" :min 0 :step ".01"}]]
                           [:td.px-5.py-2.whitespace-nowrap.text-xs.text-right {:class "w-1/12"}
                            [:a.inline-flex.justify-center.text-xs.font-bold.text-red-400.hover:text-red-700.whitespace-no-wrap
                             {:on-click #(forms/remove-many! ?change)} (tr "Remove")]]]))
                      ?changes))
          [:tbody
           [:tr [:td.min-w-full.p-5.text-center.font-bold.text-gray-500.text-sm {:col-span "7"}
                 [:span "There are currently no services marked for completion. Get started by adding a service."]]]])]]
      [:div.text-center.border-b.rounded-b-sm.border-l.border-r
       [ui/button {:variant :primary
                   :size 3
                   :class "m-3"
                   :disabled (empty? @?changes)
                   :on-click (fn [e]
                               (.preventDefault e)
                               (if (forms/submittable? !form)
                                 (forms/watch-promise
                                  !form
                                  (p/let [result (http/$lambda 'ductile.elog.interface/handle-complete-service
                                                               {:services (->> (:list/changes @!form)
                                                                               (mapv (comp #(assoc % :compound-name (util/current-compound-name))
                                                                                           util/dissoc-blank-vals)))})]
                                    (forms/clear! !form)
                                    (when (:error-message result)
                                      (reset! notice result))
                                    result))
                                 (forms/touch! !form)))}
        (tr "Mark completed")]]]]))

(defn services-list [{:keys [notice] :as state}]
  [ui/page
   [:div.min-h-screen
    [ui/nav-bar]
    (when @notice
      [ui/flash-notice {:type :error
                        :message [:div
                                  [:p.text-lg (:error-message @notice)]
                                  (into [:ul]
                                        (mapv (fn [s]
                                                [:li.font-mono.text-xs.overflow-x-auto.mt-2 [clerk.render/inspect s]])
                                              (:not-found-services @notice)))]}])
    [submitted-services-list state]
    [staged-services-list state]
    [complete-service-form state]]])

(defn render-list [_result _match]
  (r/with-let [notice (r/atom nil)]
    (let [{:keys [result]} @deframe/!current-route-fetch
          submitted-services (filter :file-exchange/file result)
          staged-services (remove :file-exchange/file result)]
      [services-list {:notice notice
                      :submitted-services (sort-by (comp :file-exchange/submitted-at :file-exchange/file)
                                                   (vec submitted-services))
                      :staged-services (sort-by (comp :file-exchange/submitted-at :file-exchange/file)
                                                (vec staged-services))}])))
